import React from 'react';
import { awardeesList } from './AwardeeData';
import AwardeeGridCard from './AwardeeGridCard';

const AwardeeSection = () => {
  return (
    <section className="px-6 py-14 md:px-12">
      <div className="mx-auto max-w-6xl">
        <h2 className="mb-8 text-center text-3xl font-bold text-accent md:text-4xl">
          OUR AWARDEES
        </h2>
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {awardeesList.map((awardee) => (
            <AwardeeGridCard key={awardee.id} awardee={awardee} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default AwardeeSection;
